let $ = jQuery.noConflict(),
	devMode,
	mobileCheck = false,
	pageTransition,
	pageTransitionEnabled = false,
	resizeCallbacks = [],
	clickOrTouch,
	mobileResizeCallbacks = [],
	smoother;

$(function () {
	new StarterKitMcube();
	// Composants Mobile & Desktop

	new SmoothScroll();

	if (mobileCheck.isMobile) {
		// Composants Mobile uniquement
	} else {
	}
	new BannerHome();
	new BannerText();
	new BlockForm();
	new BlockQuoteImage();
	new BlockScrollText();
	new BlockServices();
	new BlockSlider();
	new BlockVideo();
	new Buttons();
	new LatestEvents();
	new Header();
	new GlobalSearch();
	new TextSalvagny();
	new Typography();

});
